import React, { useEffect, useState } from 'react';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import {  message, Upload } from 'antd';
import { itemsService } from '../services/items.service';
import {  GetItemImageToEdit, SetItemImageToEdit } from '../store/itemAtom';
import { BASE_WIDTH, BASE_HEIGHT } from '../helpers/constantsFile';
import { productService } from '../services/product.service';
import { customerService } from '../services/customer.service';


const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
      return;

    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
      return ;
    }
    return isJpgOrPng && isLt2M;
  };



function AddCustomerImage(props) {
  const {onUploadedImageUrl, defaultVal} = props;
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState();
  useEffect(()=> {
    if(defaultVal){
      setImageUrl(defaultVal);
    }

   

   
   
  },[defaultVal]);



    
    const customUpload = async  ({file}) => {
       await beforeUpload(file); // check file size and type if valid

       const formData = new FormData();
       formData.append('file', file);
       customerService.uploadCustomerProfile(formData).then(res => {
        const newUrl =  res.data?.img;
        onUploadedImageUrl(newUrl);
        message.success('Upload successful');
        setImageUrl(newUrl);
       
        }).catch(err => {
          setLoading(false);
        })
     
      
      
    };


  const uploadButton = (
 
      <button  style={{  border: 0,  background: 'none'  }}type="button" >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{  margin: 8,  }}  >
        Upload
      </div>
    </button>
  );

    return ( 
        <>
           <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
       
        // onChange={onFileChange}
        // beforeUpload={beforeUpload}
        customRequest={customUpload}  // Use manual upload
        multiple={false}
      >
        {imageUrl ? (
          <>
          <img   src={imageUrl}  alt="avatar"   style={{   width: '100%',  }}  />
         
          </>
          
        ) : (    uploadButton  )}
      </Upload>

      
        </>
     );
}

export default AddCustomerImage;